<template>
	<div class="layer-project" data-project-name="glovis-aa">
		<!-- Project Name -->
		<div class="layer-project-detail">
			<!-- Page Contents -->
			<section class="project-visual">
				<div>
					<h1 class="project-tit">
						<span class="award14"></span>HYUNDAI GLOVIS
						<span class="ib">Auto Auction</span>
					</h1>
					<a href="http://www.glovisaa.com" class="link" target="_blank"
						>www.glovisaa.com</a
					>
				</div>
			</section>
			<!-- Details [s] -->
			<section class="project-overview">
				<div class="inner-section">
					<h2 class="project-overview-tit">Overview</h2>
					<p class="project-overview-txt">
						중고차 거래 사이트인 현대글로비스 오토옥션과 오토벨, 평가사 전용
						App, 모바일 영업 시스템과 서비스 전반을 관리하는 업무 시스템을
						개선한 프로젝트입니다.
						<span
							>현대글로비스 오토옥션은 내 차 사기, 카라이프 정보 등 일반 고객 및
							전문 회원사를 위한 맞춤형 중고차 거래 사이트로 개편하고, 모바일
							영업 시스템은 스마트폰에서 손쉽게 평가 및 관리 할 수 있도록
							프로세스를 간소화한 UI를 제공하도록 구성했습니다.</span
						>
					</p>
					<div class="project-overview-diagram">
						<ul class="diagram01">
							<li class="item01">Car Transaction System</li>
							<li class="item02">After-Sales Service</li>
							<li class="item03">Convenience</li>
						</ul>
						<p class="diagram02">
							<span>Glovis Auto Auction</span> <em>&amp;</em> Auto Bell
						</p>
					</div>
				</div>
			</section>

			<!-- Details [e] -->
			<section class="section full section01">
				<div class="inner-section">
					<div class="pc-web-info">
						<strong class="project-subtit"
							>Auto Auction <span>PC Web</span></strong
						>
						<p class="sub-text">
							현대글로비스 오토옥션 회원과 일반 고객의 서비스 영역을 구분하여
							사용자가 필요한 정보에 직관적으로 접근 할 수 있는 레이아웃 구조로
							작업하였습니다.
						</p>
					</div>
					<!-- Swiper -->
					<div class="pc-web-slider swiper-container">
						<ul class="swiper-wrapper clfix">
							<li class="swiper-slide item01">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/glovis-aa/pc-web-img-01@m.png"
								/>
							</li>
							<li class="swiper-slide item02">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/glovis-aa/pc-web-img-02@m.png"
								/>
							</li>
							<li class="swiper-slide item03">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/glovis-aa/pc-web-img-03@m.png"
								/>
							</li>
							<li class="swiper-slide item04">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/glovis-aa/pc-web-img-04@m.png"
								/>
							</li>
							<li class="swiper-slide item05">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/glovis-aa/pc-web-img-05@m.png"
								/>
							</li>
						</ul>

						<!-- Add Pagination -->
						<div class="swiper-pagination pc-web-pagination"></div>
					</div>
				</div>
			</section>

			<section class="section section02">
				<div class="inner-section">
					<div class="pc-web-info">
						<strong class="project-subtit"
							>Auto Auction <span>App</span></strong
						>
						<p class="sub-text">
							웹 사이트와 동일하게 현대글로비스 오토옥션 회원과 일반 고객의
							서비스 영역을 구분하여 구성하였고 모바일 환경에 최적화된 UI/UX를
							제공하고 있습니다.
						</p>
					</div>
					<div class="app-image-area">
						<div class="img">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/glovis-aa/app-img-01@m.png"
							/>
						</div>
					</div>
				</div>
			</section>

			<section class="section full section03">
				<div class="inner-section">
					<div class="img">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/glovis-aa/app-img-02@m.png"
						/>
					</div>
				</div>
			</section>

			<section class="section full section04">
				<div class="inner-section">
					<div class="auto-bell-info">
						<strong class="project-subtit"
							>Auto Bell Web <span>(PC/Mobile)</span></strong
						>
						<p class="sub-text">
							오토벨은 현대글로비스 오토옥션과 연계된 사이트로 현대자동차그룹의
							톤 앤 매너를 유지하여 현대자동차그룹의 아이덴티티를 유지하고
							<span class="ib">풀 이미지와</span> 배너형 디자인으로 오토옥션과
							차별화하여 구성했습니다.
						</p>
					</div>
					<div class="img">
						<img
							src=""
							alt=""
							data-src="/static/img/project-detail/glovis-aa/auto-bell-web-img@m.png"
						/>
					</div>
				</div>
			</section>

			<section class="section section05">
				<div class="inner-section">
					<div class="point-top-area clfix">
						<div class="point-font-area">
							<div class="img">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/glovis-aa/point-font@m.png"
								/>
							</div>
						</div>
						<div class="point-color-area">
							<div class="img">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/glovis-aa/point-color@m.png"
								/>
							</div>
						</div>
					</div>
					<div class="point-icon-area">
						<div class="img">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/glovis-aa/point-icon@m.png"
							/>
						</div>
					</div>
				</div>
			</section>

			<section class="project-client">
				<strong class="a11y-hidden">HYUNDAI GLOVIS Auto Auction</strong>
			</section>

			<!-- Page Contents -->
		</div>

		<app-pjmove></app-pjmove>
	</div>
</template>

<script>
import Swiper from "../../static/js/swiper.min.js"; /* if use swiper.min.js */
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		this.projectInit();

		var $window = $(window);
		var winW = $window.outerWidth();
		var flag = true;
		var isSlider = true;
		var pcwebSwiper;

		var pcWeb = function () {
			if (isSlider) {
				isSlider = false;
				pcwebSwiper = new Swiper(".pc-web-slider", {
					spaceBetween: 15,
					pagination: {
						el: ".pc-web-pagination",
						clickable: true,
					},
				});
			}
		};

		if (winW < 712) {
			pcWeb();
		} else {
			isSlider = true;
		}

		$window.on("resize", function () {
			winW = $window.outerWidth();
			if (winW < 712) {
				if (flag) {
					flag = false;
					pcWeb();
				}
			} else {
				flag = true;
				if (!isSlider) {
					isSlider = true;
					pcwebSwiper.destroy();
					$(".swiper-pagination").children().remove();
				}
			}
		});
	},
};
</script>
<!-- css 추가 -->
<style>
@import "../../static/css/swiper.min.css"; /* if use swiper.min.js */
@import "../../static/css/projects.css"; /* Common Project Detail Page */
</style>
<style scoped>
/* Common */
.sub-text {
	word-break: keep-all;
}
.img {
	text-align: center;
}
@media screen and (max-width: 711px) {
}
@media screen and (min-width: 712px) {
}
@media screen and (min-width: 1280px) {
}

/* Project Visual, Project CI */
.project-client {
	background: url(/static/img/project-detail/glovis-aa/ci.png) 50% / auto 39px
		no-repeat;
}
@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/glovis-aa/bg-overview@m.jpg);
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/glovis-aa/bg-overview@t.jpg);
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/glovis-aa/bg-overview@w.jpg);
	}
	.project-client {
		background-size: auto 78px;
	}
}

/* Overview */
.project-overview {
	background-color: #4064c4;
	color: #fff;
}
.project-overview-txt {
	margin-bottom: 30px;
}
.project-overview-diagram {
	font-weight: 500;
	line-height: 1.7rem;
}
.project-overview-diagram .diagram01 {
	position: relative;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	margin-bottom: 10px;
	padding-top: 12.5px;
	padding-bottom: 32.5px;
}
.project-overview-diagram .diagram01:after {
	content: "";
	position: absolute;
	bottom: 0px;
	left: 50%;
	width: 1px;
	height: 40px;
	background-color: #fff;
}
.project-overview-diagram li {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 138px;
	height: 138px;
	margin: -12.5px -3.5px;
	padding: 10px;
	border-radius: 50%;
	border: 1px solid #fff;
	text-align: center;
}
.project-overview-diagram .diagram02 {
	display: flex;
	flex-wrap: wrap;
	flex-flow: column;
	justify-content: center;
	align-items: center;
	width: 138px;
	height: 138px;
	margin: 0 auto;
	padding: 20px;
	border-radius: 50%;
	text-align: center;
	background-color: #fff;
	color: #4064c4;
}
.project-overview-diagram .diagram02 span {
	font-size: 1.6rem;
}

@media screen and (max-width: 711px) {
	.project-overview-txt span {
		display: block;
	}
}
@media screen and (min-width: 712px) {
	.project-overview {
		padding-bottom: 35px;
	}
	.project-overview-diagram {
		display: flex;
		justify-content: center;
	}
	.project-overview-diagram .diagram01 {
		margin-bottom: 0;
		padding-top: 0;
		padding-bottom: 0;
		padding-right: 68px;
	}
	.project-overview-diagram .diagram01:after {
		bottom: 50%;
		left: auto;
		right: 0;
		width: 89px;
		height: 1px;
	}
	.project-overview-diagram li {
		margin: 0;
	}
	.project-overview-diagram li + li {
		margin-left: -8px;
	}
	.project-overview-diagram .diagram02 {
		margin-left: 28px;
		margin-right: 0;
	}
}
@media screen and (min-width: 1280px) {
	.project-overview .inner-section {
		padding-bottom: 30px;
	}
	.project-overview-txt span {
		display: block;
	}
	.project-overview-diagram li,
	.project-overview-diagram .diagram02 {
		width: 230px;
		height: 230px;
		font-size: 20px;
	}
	.project-overview-diagram li {
		border-width: 2px;
		padding: 60px;
		line-height: 1.5;
	}
	.project-overview-diagram li + li {
		margin-left: -14px;
	}
	.project-overview-diagram .diagram01 {
		padding-right: 208px;
	}
	.project-overview-diagram .diagram01:after {
		bottom: calc(50% - 1px);
		left: auto;
		right: 0;
		width: 178px;
		height: 2px;
	}
	.project-overview-diagram .diagram02 {
		line-height: 1.2;
	}
	.project-overview-diagram .diagram02 span {
		font-size: 28px;
	}
}

.section.section01 {
	padding-bottom: 0;
}
.section01 .inner-section {
	position: relative;
}
.section01 .pc-web-info {
	margin-bottom: 35px;
	padding: 0 15px;
}
.section01 .pc-web-slider {
	padding: 0 15px 40px;
}
.section01 .pc-web-slider li {
	text-align: center;
}
.section01 .pc-web-slider img {
	box-shadow: 0 17px 20px rgba(0, 0, 0, 0.22);
}
@media screen and (max-width: 711px) {
	.section01 .project-subtit span {
		display: block;
	}
}
@media screen and (min-width: 712px) {
	.section01 {
		position: relative;
	}
	.section01:before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 56.1797vw;
		background-color: #ededed;
	}
	.section01 .pc-web-info {
		padding: 0 40px;
	}
	.section01 .pc-web-slider {
		padding: 0 40px;
	}
	.section01 .pc-web-slider.swiper-container {
		overflow: visible;
	}
	.section01 .pc-web-slider .swiper-wrapper {
		display: block;
	}
	.section01 .pc-web-slider .swiper-wrapper li {
		float: left;
		margin-bottom: 40px;
	}
	.section01 .pc-web-slider .swiper-wrapper li:not(.item01) {
		width: 42.1348vw;
		margin-bottom: 5vw;
	}
	.section01 .pc-web-slider .swiper-wrapper li:nth-child(2n + 3) {
		float: right;
	}
	.section01 .pc-web-slider .swiper-wrapper li.item03 {
		margin-bottom: 11.6741vw;
	}
	.section01 .pc-web-slider .swiper-wrapper li.item05 {
		margin-top: -44px;
	}
}
@media screen and (min-width: 1280px) {
	.section01:before {
		height: 836px;
	}
	.section01 .inner-section {
		padding: 60px 0 0;
	}
	.section01 .pc-web-info {
		max-width: 1280px;
		margin: 0 auto 60px;
		padding: 0 20px;
	}
	.section01 .pc-web-slider {
		padding: 0;
	}
	.section01 .pc-web-slider .swiper-wrapper {
		max-width: 1238px;
		margin: 0 auto;
	}
	.section01 .pc-web-slider .swiper-wrapper li {
		margin-bottom: 80px;
	}
	.section01 .pc-web-slider .swiper-wrapper li:not(.item01) {
		width: 600px;
		margin-bottom: 80px;
	}
	.section01 .pc-web-slider .swiper-wrapper li.item03 {
		margin-bottom: 175px;
	}
	.section01 .pc-web-slider .swiper-wrapper li.item05 {
		margin-top: -95px;
	}
}
.section.section02 {
	padding-bottom: 0;
}
.section02 .pc-web-info {
	margin-bottom: 35px;
}
.app-image-area {
	padding-top: 22px;
	background: url(/static/img/project-detail/glovis-aa/app-text-bg@m.png)
		no-repeat;
	background-size: 100% auto;
}
@media screen and (max-width: 711px) {
}
@media screen and (min-width: 712px) {
	.section.section02 {
		padding-top: 20px;
	}
	.section02 .pc-web-info {
		margin-bottom: 15px;
	}
	.app-image-area {
		background-image: url(/static/img/project-detail/glovis-aa/app-text-bg@t.png);
	}
	.app-image-area .img img {
		width: 59.90168vw;
	}
}
@media screen and (min-width: 1280px) {
	.section02 .inner-section {
		position: relative;
		max-width: 1440px;
	}
	.section02 .pc-web-info {
		position: absolute;
		top: 130px;
		left: calc(50% - 620px);
		width: 430px;
	}
	.section02 .pc-web-info .sub-text {
		padding-right: 110px;
	}
	.app-image-area {
		padding-right: 140px;
		background-image: url(/static/img/project-detail/glovis-aa/app-text-bg@w.png);
	}
	.app-image-area .img {
		text-align: right;
	}
	.app-image-area .img img {
		width: auto;
	}
}
.section.full.section03 {
	padding-bottom: 0;
}
@media screen and (max-width: 711px) {
	.section03 .inner-section {
		position: relative;
		height: 1025.5px;
	}
	.section03 .img {
		position: absolute;
		top: 0;
		left: 50%;
		width: 574.5px;
		transform: translateX(-50%);
	}
}
@media screen and (min-width: 712px) {
	.section03 .img img {
		width: 80.6179vw;
	}
}
@media screen and (min-width: 1280px) {
	.section.full.section03 {
		padding-top: 0;
	}
	.section03 .img img {
		width: auto;
	}
}
.section.full.section04 {
	padding-bottom: 0;
}
.section04 {
	position: relative;
}
.section04:after {
	content: "";
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 53.125vw;
	background-color: #485f91;
}
.section04 .inner-section {
	position: relative;
	z-index: 1;
}
.auto-bell-info {
	margin-bottom: 26px;
	padding: 0 15px;
}
@media screen and (max-width: 711px) {
}
@media screen and (min-width: 712px) {
	.section04:after {
		height: 59.5505vw;
	}
	.auto-bell-info {
		padding: 0 40px;
	}
	.section04 .img img {
		width: 93.5393vw;
	}
}
@media screen and (min-width: 1280px) {
	.section04:after {
		height: 808px;
	}
	.section04 .inner-section {
		padding-top: 60px;
		padding-bottom: 120px;
	}
	.auto-bell-info {
		max-width: 1280px;
		margin: 0 auto 40px;
		padding: 0 20px;
	}
	.section04 .img img {
		width: auto;
	}
}
.section05 {
	background-color: #3e3f44;
}
.point-font-area img {
	width: 90.625vw;
}
.point-color-area img {
	width: 90.15625vw;
}
@media screen and (max-width: 711px) {
	.point-font-area {
		margin-bottom: 30px;
	}
	.point-color-area {
		margin-bottom: 25px;
	}
}
@media screen and (min-width: 712px) {
	.point-top-area {
		margin-bottom: 10px;
		padding-left: 45px;
		padding-right: 30px;
	}
	.point-font-area {
		float: left;
	}
	.point-font-area img {
		width: 44.5926vw;
	}
	.point-color-area {
		float: right;
	}
	.point-color-area img {
		width: 27.1067vw;
	}
	.point-icon-area {
		padding: 0 45px;
	}
}
@media screen and (min-width: 1280px) {
	.section05 .inner-section {
		padding-top: 60px;
		padding-bottom: 120px;
		padding-right: 0;
	}
	.point-top-area {
		padding: 0;
	}
	.point-font-area img {
		width: auto;
	}
	.point-color-area img {
		width: auto;
	}
	.point-icon-area {
		padding: 0;
		padding-right: 20px;
	}
}
</style>



// WEBPACK FOOTER //
// src/projects/glovis-aa.vue